<a routerLinkActive="active" [routerLink]="route"
class="side-menu-item justify-content-start no-outline text-left btn btn-icon btn-sm btn-theme-dark w-100">
<i class="ml-2 mr-1 f-20 mdi {{icon}}"></i>
<span>{{label}}</span>
</a>